import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { endpoints, asset } from "@/lib/api";
import { PageHeader, CTASection } from "@/components/site/Bits";
import { Reveal, ClippedImage } from "@/lib/motion";

export default function CaseStudiesIndex() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    endpoints.caseStudies().then(setItems).catch(() => {});
  }, []);

  return (
    <div data-testid="case-studies-page">
      <PageHeader
        eyebrow="Case Studies"
        title={["Evenings", "worth retelling."]}
        intro="A selection of occasions ARIA has been privileged to host — each a study in atmosphere, detail and quiet precision."
        testid="case-studies-header"
      />

      <section className="aria-container pb-28 md:pb-40">
        <div className="flex flex-col gap-24 md:gap-36">
          {items.map((cs, i) => (
            <Reveal key={cs.id}>
              <Link
                to={`/case-studies/${cs.slug}`}
                data-testid={`case-study-card-${cs.slug}`}
                className={`group grid grid-cols-1 items-center gap-10 md:grid-cols-12 md:gap-16 ${
                  i % 2 === 1 ? "md:[direction:rtl]" : ""
                }`}
              >
                <div className="md:col-span-7 md:[direction:ltr]">
                  <ClippedImage src={cs.hero_image} alt={cs.title} aspect="aspect-[16/10]" />
                </div>
                <div className="md:col-span-5 md:[direction:ltr]">
                  <div className="text-[0.7rem] uppercase tracking-[0.24em] text-aria-brass">
                    {cs.location} · {cs.year}
                  </div>
                  <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-aria-ink transition-colors group-hover:text-aria-cocoa">
                    {cs.title}
                  </h2>
                  <p className="mt-6 max-w-md font-light leading-relaxed text-aria-cocoa/75">{cs.overview}</p>
                  <div className="mt-8 flex gap-10 text-[0.7rem] uppercase tracking-[0.2em] text-aria-muted">
                    <span>{cs.guest_count}</span>
                    <span>{cs.client_type}</span>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
